import { Component } from "@angular/core";

@Component({
  selector: "app-ifp",
  templateUrl: "./ifp.component.html",
  styleUrls: ["./ifp.component.scss"],
})
export class IfpComponent {
  featureData = [
    {
      title: "Interactive Touchscreen",
      iconSrc: "assets/images/icons/panel/interactive-touchscreen.png",
      description:
        "Engage students with a responsive interface for seamless interaction with digital content.",
    },
    {
      title: "Multi-User Collaboration",
      iconSrc: "assets/images/icons/panel/multi-user-collaboration.png",
      description:
        "Foster teamwork and peer learning with simultaneous interaction capabilities.",
    },
    {
      title: "Digital Whiteboarding",
      iconSrc: "assets/images/icons/panel/digital-whiteboarding.png",
      description:
        "Transform sessions into dynamic experiences for real-time problem-solving.",
    },
    {
      title: "Multimedia Integration",
      iconSrc: "assets/images/icons/panel/multimedia-integration.png",
      description:
        "Enhance understanding with integrated videos, images, and simulations.",
    },
    {
      title: "Annotation Tools",
      iconSrc: "assets/images/icons/panel/annotation-tools.png",
      description:
        "Enable personalized instruction through on-screen mark-up and highlighting.",
    },
    {
      title: "Remote Learning",
      iconSrc: "assets/images/icons/panel/remote-learning.png",
      description:
        "Ensure education continuity with access to interactive lessons from anywhere.",
    },
    {
      title: "Adaptive Learning Apps",
      iconSrc: "assets/images/icons/panel/learning-apps.png",
      description:
        "Tailor learning experiences to individual needs and styles.",
    },
    {
      title: "Assessment Tools",
      iconSrc: "assets/images/icons/panel/assessment-tools.png",
      description:
        "Streamline assessment with quizzes and instant feedback mechanisms.",
    },
    {
      title: "Accessibility Features",
      iconSrc: "assets/images/icons/panel/accessibility-features.png",
      description:
        "Accommodate diverse learning needs with inclusive accessibility options.",
    },
    // {
    //   title: "Cloud Integration",
    //   iconSrc: "assets/images/icons/panel/cloud.png",
    //   description:
    //     "Seamlessly share resources and collaborate on lesson planning in the cloud.",
    // },
  ];
}
